/**
 * SelectField — BLU-006-styled native <select> for public/profile forms.
 *
 * Matches the bordered Bitter-input look of TextInput (2px charcoal border,
 * Bebas teal label) used on the public pages, so dropdowns sit consistently
 * alongside text inputs (SPR-009 P2-5/P2-6). Native <select> keeps it
 * dependency-free and accessible.
 *
 * @param {{
 *   label?: string,
 *   name: string,
 *   value: string,
 *   onChange: (e) => void,
 *   options: Array<{ value: string, label: string }>,
 *   placeholder?: string,
 *   testId?: string,
 * }} props
 */
export default function SelectField({
  label,
  name,
  value,
  onChange,
  options,
  placeholder,
  testId,
}) {
  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block font-heading tracking-widest text-teal-deep text-sm mb-1"
        >
          {label}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        data-testid={testId ?? name}
        className="w-full border-2 border-charcoal rounded-xl px-3 py-2 font-body text-ink bg-white focus:outline-none focus:border-teal focus:ring-1 focus:ring-teal"
      >
        {placeholder != null && (
          <option value="">{placeholder}</option>
        )}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
